<template>
  <v-container class="cmp-catalog-products-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedProductDetails &&
              selectedProductDetails.product_title_lines &&
              selectedProductDetails.product_title_lines.line1
            "
          >
            <span v-if="selectedProductDetails">{{
              selectedProductDetails.product_title_lines.line1 || $t('product')
            }}</span>
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div>
                {{ selectedProductDetails.product_title_lines.line2 }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <glayout
        :tabs="productSidewindowTabs"
        :menu="menuOptions"
        :options="[
          {
            text: $t('documents_string'),
            value: 'documents',
          },
          
        ]"
        :loading="selectedProductDetails && selectedProductDetails.loading"
        @optionClicked="onTabOptionClicked"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :title="$t('product_setup')"
                :h="productSetupHeight.h"
                :maxH="productSetupHeight.maxH"
              >
                <ProductSetup
                  :selectedProductDetails="selectedProductDetails"
                  :isPhysical="isPhysical"
                  @changed="onProductChange"
                />
              </gbox>
              <gbox
                v-if="isPhysical"
                :title="$t('prices')"
                :h="
                  boxHeight(
                    selectedProductDetails &&
                      selectedProductDetails.pricelists &&
                      selectedProductDetails.pricelists.length
                  )
                "
                :selected="true"
              >
                <Prices
                  :selectedProductDetails="selectedProductDetails"
                  @delete="onDeletePrice"
                  @load="onPriceLoad"
                  @add_product_prices="onPriceLoad"
                  @changed="onPriceChange"
                />
              </gbox>
              <gbox :title="$t('notes')" bc="var(--bc-note)">
                <DBoxTextarea
                  :value="selectedProductDetails.product.notes"
                  :id="'notes'"
                  @blur="
                    (e) =>
                      onProductChange({
                        name: 'notes',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="$t('advanced_product_setup')"
                :h="isPhysical ? 370 : 242"
                :maxH="isPhysical ? 434 : 306"
              >
                <AdvancedProductSetup
                  :selectedProductDetails="selectedProductDetails"
                  :isPhysical="isPhysical"
                  @changed="onProductChange"
                />
              </gbox>
              <gbox v-if="isPhysical" :title="$t('stock_location')" h="99">
                <StockLocation
                  :selectedProductDetails="selectedProductDetails"
                  @changed="onProductChange"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedProductDetails &&
                      selectedProductDetails.groups &&
                      selectedProductDetails.groups.length,
                    NTOffsets.WithDBoxBottom,
                    32
                  )
                "
                :title="$t('submenu_GROUPS')"
              >
                <DBox
                  :id="'catalog-product-groups'"
                  :addButton="false"
                  :addLink="true"
                  :addLinkLabel="$t('add') + ' ' + $t('groups')"
                  @add_click="addgroupClick"
                >
                  <DList
                    :items="selectedProductDetails.groups"
                    :primaryKey="'product_group_id'"
                    :labelKey="'product_group_name1'"
                    :clickable="true"
                    @delete="ongroupDelete"
                    @item_click="onGroupClick"
                  >
                  </DList>
                </DBox>
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
             
                :h="
                  boxHeight(
                    selectedProductDetails &&
                    selectedProductDetails.releases &&
                    selectedProductDetails.releases.length,
                    NTOffsets.WithHeader
                  )
                "
                :title="$t('related_release')"
              >
                <ProductReleatedRelease
                  :releases="releatedReleases"
                  @selected="onSelectedRelease"
                  @changed="onUpdated"
                />
              </gbox>
              <gbox
                v-if="isPhysical"
                :h="
                  boxHeight(
                    selectedProductDetails &&
                      selectedProductDetails.accounts &&
                      selectedProductDetails.accounts.length
                  )
                "
                :title="$t('accounts')"
              >
                <Accounts
                  :selectedProductDetails="selectedProductDetails"
                  @changed="onPriceChange"
                  @delete="onAccountDelete"
                  @loadAccounts="onLoadAccounts"
                />
              </gbox>
              <!-- <gbox
                v-if="!isPhysical"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProductDetails &&
                      selectedProductDetails.only_tracks &&
                      selectedProductDetails.only_tracks.length,
                    offset: NTOffsets.WithHeader,
                    min: 1,
                  })
                "
                :title="$t('media')"
              >
                <OnlyTracks
                  :selectedProductDetails="selectedProductDetails"
                  @change="onUpdateOnlyTrack"
                />
              </gbox> -->
            </gcol>
          </grow>
        </gtab>
        <gtab id="tab_title_tasks">
          <grow>
       
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProductDetails &&
                      selectedProductDetails.tasks &&
                      selectedProductDetails.tasks.length,
                    min: 1,
                  })
                "
                :title="$t('tab_title_tasks')"
              >
                <DTTaskList :storeConfig="dBoxTaskConfig" :selectedDetails="selectedProductDetails" :externalTable="'product'"/>
              </gbox>
            
          </grow>
        </gtab>
        <gtab id="products_tracks">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProductDetails &&
                      selectedProductDetails.tracks &&
                      selectedProductDetails.tracks.length,
                    min: 1,
                  })
                "
                :title="`${$t('tracklisting')} (${trackLength})`"
              >
                <Tracklisting
                  :selectedProductDetails="selectedProductDetails"
                  @updatePlayTime="updatePlayTime"
                  @delete="onDeleteTrack"
                  @setDuplicateModalData="setDuplicateModalData"
                  @changed="onTrackChange"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                v-if="isPhysical"
                :h="
                  boxHeight(
                    selectedProductDetails &&
                      selectedProductDetails.product_medias &&
                      selectedProductDetails.product_medias.length
                  )
                "
                :title="$t('gema')"
              >
                <GEMA
                  :selectedProductDetails="selectedProductDetails"
                  @delete="onDeleteProductMedia"
                  @changed="onPriceChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="products_info">
          <grow>
            <gcol>
              <gbox :title="$t('product_information')">
                <ProductInfo
                  :selectedProductDetails="selectedProductDetails"
                  @changed="onProductChange"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox :title="$t('product_info_english')">
                <DBoxTextarea
                  :value="
                    selectedProductDetails &&
                    selectedProductDetails.product.product_info_english
                  "
                  :maxHeight="625"
                  :yellowStyle="false"
                  :id="'product_info_english'"
                  @blur="
                    (e) =>
                      onProductChange({
                        name: 'product_info_english',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
              <gbox h="308" :title="$t('artwork_cover')">
                <Artwork
                  :artwork1="selectedProductDetails.artwork1"
                  :artwork2="selectedProductDetails.artwork2"
                  :externalId="`${this.selectedProductDetails.product.product_id}`"
                  :externalTable="'product'"
                  :externalKey="'product_id'"
                  :section="'products'"
                  @artworkChanged="onArtworkChanged"
                  @done="onArtworkUploadDone"
                />
              </gbox>
            </gcol>
            <gcol>

              <gbox :title="$t('product_info_second')">
                <DBoxTextarea
                  :value="
                    selectedProductDetails &&
                    selectedProductDetails.product.product_info_second
                  "
                  :yellowStyle="false"
                  :maxHeight="625"
                  :id="'product_info_second'"
                  @blur="
                    (e) =>
                      onProductChange({
                        name: 'product_info_second',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedProductDetails &&
                      selectedProductDetails.files &&
                      selectedProductDetails.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedProductDetails.files"
                  :externalId="`${this.selectedProductDetails.product.product_id}`"
                  :externalTable="'product'"
                  @fileDelete="onFileDelete"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="products_costs">
          <template #header>
            <grow>
              <gcol>
                <div class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button dt-button v5 s8"
                    @click="onProductCostAccountAll"
                  >
                    {{$t('account_all')}}
                  </button>
                  <span class="ut-text-secondary">
                    {{$t('total_product')}}:
                    {{ $dft.curr(selectedProductDetails.product_costs_total) }}
                    {{ $store.getters.account.client.default_currency }}
                  </span>
                </div>
              </gcol>
            </grow>
          </template>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: dBoxCostsRowCount,
                    offset:
                      selectedProductDetails &&
                      selectedProductDetails.costs &&
                      selectedProductDetails.costs.length > 0
                        ? dBoxCostSearchFlag
                          ? NTOffsets.WithHeaderDBoxBottom + 52
                          : NTOffsets.WithHeaderDBoxBottom
                        : dBoxCostSearchFlag
                        ? NTOffsets.WithHeaderDBoxBottom + 52
                        : NTOffsets.WithHeaderDBoxBottom,
                  })
                "
                :title="$t('related_costs')"
              >
                <DboxCosts
                  :items="selectedProductDetails.costs || []"
                  :cost_groups="
                    (productsCatalogData && productsCatalogData.cost_groups) ||
                    []
                  "
                  :storeConfig="dboxCostConfig"
                  @updated="onProductCostUpdated"
                  @showSearchFlag="onDBoxCostSearchFlagChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="products_other_income">
          <template #header>
            <grow>
              <gcol>
                <div class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button dt-button v5 s8"
                    @click="onProductIncomeAccountAll"
                  >
                    {{$t('account_all')}}
                  </button>
                  <span class="ut-text-secondary">
                    {{$t('total_product')}}:
                    {{
                      $dft.curr(
                        selectedProductDetails.release_income_product_costs_total
                      )
                    }}
                    {{ $store.getters.account.client.default_currency }}
                  </span>
                </div>
              </gcol>
            </grow>
          </template>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: dBoxOtherIncomesRowCount,
                    offset:
                      selectedProductDetails &&
                      selectedProductDetails.other_incomes &&
                      selectedProductDetails.other_incomes.length > 0
                        ? dBoxOtherIncomeSearchFlag
                          ? NTOffsets.WithHeaderDBoxBottom + 52
                          : NTOffsets.WithHeaderDBoxBottom
                        : dBoxOtherIncomeSearchFlag
                        ? NTOffsets.WithHeaderDBoxBottom + 52
                        : NTOffsets.WithHeaderDBoxBottom,
                  })
                "
                :title="$t('related_other_income')"
              >
                <DboxCosts
                  :items="selectedProductDetails.other_incomes || []"
                  :cost_groups="
                    (productsCatalogData && productsCatalogData.cost_groups) ||
                    []
                  "
                  :storeConfig="dboxCostIncomeConfig"
                  @showSearchFlag="onDBoxOtherIncomeSearchFlagChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="products_royalty">
          <template #header>
            <grow>
              <gcol>
                <div class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onRoyaltyReleaseUpdate"
                  >
                    {{$t('update_release_contract')}}
                  </button>
                </div>
              </gcol>
            </grow>
          </template>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProductDetails &&
                      selectedProductDetails.contract &&
                      selectedProductDetails.contract.contracts &&
                      selectedProductDetails.contract.contracts.length &&
                      selectedProductDetails.contract.contracts.length > 0
                        ? selectedProductDetails.contract.contracts.length
                        : 0,
                    rowHeight: 64*3,
                    offset: NTOffsets.WithHeader,
                    min: 1,
                    max: 8,
                  })
                "
                :title="$t('royalties')"
              >
                <Royalty
                  @changed="onRoyaltyChange"
                  :selectedProductDetails="selectedProductDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="products_sales">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: dBoxSalesRowCount,
                    rowHeight: 48,
                    offset:
                      selectedProductDetails &&
                      selectedProductDetails.salesData &&
                      selectedProductDetails.salesData.sales &&
                      selectedProductDetails.salesData.sales.length > 0
                        ? dBoxSalesSearchFlag
                          ? NTOffsets.WithHeaderDBoxBottom + 55
                          : NTOffsets.WithHeaderDBoxBottom
                        : dBoxSalesSearchFlag
                        ? NTOffsets.WithHeaderDBoxBottom + 20
                        : NTOffsets.WithHeaderDBoxBottom - 20,
                    min: 1,
                    max: 10,
                  })
                "
                :title="$t('ds_sales')"
              >
                <DBoxSales
                  @showSearchFlag="onDBoxSalesSearchClick"
                  :storeConfig="dboxSalesStoreConfig"
                  :showTotal="true"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="products_stock" v-if="isPhysical">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: selectedProductDetails &&
                      selectedProductDetails.accounts_stock &&
                      selectedProductDetails.accounts_stock.length,
                    min: 1,
                  })
                "
                :title="$t('stock_levels')"
              >
                <Stocks
                  :selectedProductDetails="selectedProductDetails"
                  @editStockModal="setSelectedStock"
                />
              </gbox>

            </gcol>

          </grow>
          <grow>
            <gcol>

              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProductDetails &&
                      selectedProductDetails.manufacturing_orders &&
                      selectedProductDetails.manufacturing_orders.length,
                    min: 1,
                  })
                "
                :title="$t('manufacturing')"
              >
                <Manufacture :selectedProductDetails="selectedProductDetails" />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedProductDetails &&
                      selectedProductDetails.orderlines &&
                      selectedProductDetails.orderlines.length
                  )
                "
                :title="$t('supplier_order')"
              >
                <StockSupplyOrder
                  :selectedProductDetails="selectedProductDetails"
                 
                />
              </gbox>


            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProductDetails &&
                      selectedProductDetails.backorders &&
                      selectedProductDetails.backorders.length,
                    min: 1,
                  })
                "
                :title="$t('backorders')"
              >
                <BackOrders
                  :selectedProductDetails="selectedProductDetails"
                  @delete="onDeleteBackOrder"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProductDetails &&
                      selectedProductDetails.open_orders &&
                      selectedProductDetails.open_orders.length,
                    min: 1,
                  })
                "
                :title="$t('open_orders')"
              >
                <OpenOrder
                  :selectedProductDetails="selectedProductDetails"
                  @delete="onDeleteOpenOrder"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: 3,
                    offset: NTOffsets.default,
                    min: 3,
                    max: 3,
                    rowHeight: 32,
                  })
                "
                :title="$t('setup')"
              >
                <StockSetup
                  :selectedProductDetails="selectedProductDetails"
                  @changed="onProductChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="products_specials">
          <grow>
            <gcol>
              <!-- :h="
                  boxHeight(
                    selectedProductDetails &&
                      selectedProductDetails.countries_allowed &&
                      selectedProductDetails.countries_allowed.length,
                    undefined,
                    undefined,
                    5
                  )
                " -->
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: countriesRowCount,
                    offset: NTOffsets.WithDBoxBottom,
                    rowHeight: 32,
                    min: 1,
                    max: 6,
                  })
                "
                :title="$t('country_restrictions')"
              >
                <CountryRestriction
                  @delete="onCountryDelete"
                  :selectedProductDetails="selectedProductDetails"
                  @remove="onRemoveClick"
                  @invert="onInvertClick"
                />
              </gbox>
              <gbox :title="$t('harry_fox')">
                <HarryFox :selectedProductDetails="selectedProductDetails" />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedProductDetails &&
                      selectedProductDetails.match_accounts &&
                      selectedProductDetails.match_accounts.length
                  )
                "
                :title="$t('manual_matches')"
              >
                <ManualMatches
                  @delete="onManualMatchDelete"
                  :selectedProductDetails="selectedProductDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="products_metadata">
          <grow>
            <gcol>
              <gbox h="100%" :title="$t('metadata')">
                <Metadata
                  @changed="onMetaDataUpdate"
                  :detailsObject="selectedProductDetails"
                />
              </gbox>
            </gcol>
            <!-- <gcol> </gcol> -->
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer
      :modalKey="'addProductGroup'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddGroupModal @create="onAddGroup" @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addProductAccount'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddAccountModal @create="onAddAccount" @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addProductMedia'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddProductMediaModal
        @added="onAddProductMedia"
        @edited="onUpdateProductMedia"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addManufacture'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddManufactureModal @create="onAddManufacture" @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addBackOrder'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddBackOrderModal @create="onAddBackOrder" @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addManualMatch'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddManualManualMatches
        @create="onAddManualMatch"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addMechanicalRate'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <SelectMechanicalRate
        @save="onSaveMechanicalRate"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addCountryRestrict'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <CountryRestrictionModal
        @create="onAddCountryRestrict"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'editStock'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <EditStockModal
        v-if="selectedProductDetails.accounts_stock && selectedStock"
        :selectedStock="selectedStock"
        :stockList="selectedProductDetails.accounts_stock"
        @changed="onEditStock"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addTrack'"
      :width="modalWidth"
      @cancelled="onCancel"
    >
      <AddTrackListModal
        @create="onAddTrackList"
        @cancelled="onCancel"
        @changeWidth="onChangeWidth"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'duplicateTrackModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <DuplicateTrackModal
        v-if="selectedTrack"
        :selectedTrack="selectedTrack"
        @create="onAddTrackList"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'copyTrackModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <CopyTrackModal @create="onCopyTrackList" @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      :modalKey="'templateList'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <TemplateModal @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      :modalKey="'stockRelocationModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <StockRelocationModal @relocate="stockMove" @cancelled="onCancel" />
    </ModalContainer>
    
  </v-container>
</template>

<script>
import { CatalogStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";

import VueGridLayout from "vue-grid-layout";
import BoxWidget from "@plugins/box-widget/box-widget";
import {
  createGridHost,
  createSidewindowTabulation,
} from "../../../../dt-plugins/sidewindow";
import { productDetailsGrid, productGridItemRouteMap } from "./sw-grid";

import { mapGetterObject, mapActionObject } from "../../../../store/global";

import { openWindow, sendMailHref, wait } from "../../../../utility";

import {
  releasesListLDTRoutes,
  productGroupsLDTRoutes,
  productsListLDTRoutes,
} from "../../router/routes";
import {
  checkTabListPermission,
  checkTabGridItemPermission,
} from "../../../../router/guard";

import {
  createModalMixin,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import { createTV, tv } from "../../../../models/text-value.model";
import { createCurrencyTV } from "../../../../models/currency.model";
import { createLanguageTV } from "../../../../models/language.model";
import { createUserTV } from "../../../../models/user.model";
import { pathOr } from "ramda";

import DBox from "@dtplugins/dbox/dbox";
import DList from "@dtplugins/list/dlist";
import DBoxTextarea from "@dtplugins/dbox-textarea/dbox-textarea";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import Artwork from "@dtplugins/artwork/artwork";

import { productsCatalogGetters } from "../../store/products/getters";
import { productsCatalogActions } from "../../store/products/actions";

import StockSetup from "./stock-setup";
import ProductSetup from "./product-setup";
import AdvancedProductSetup from "./advanced-product-setup";
import StockLocation from "./stock-location";
import Prices from "./prices";
import Accounts from "./accounts";
import Tracklisting from "./tracklisting";
import GEMA from "./gema";
import ProductInfo from "./product-info";
import AddGroupModal from "./add-group-modal";
import AddAccountModal from "./account-add-modal";
import AddProductMediaModal from "./product-media-form";
import Manufacture from "./manufacturing";
import AddManufactureModal from "./add-manufacture-modal";
import Stocks from "./stocks";
import StockSupplyOrder from "./stock-supply-order.vue";
import BackOrders from "./back-orders";
import ManualMatches from "./manual-matches";
import AddBackOrderModal from "./add-back-order-modal";
import StockRelocationModal from "./stock-relocation-modal.vue";
import AddManualManualMatches from "./add-manual-matches-modal";
import CountryRestriction from "./country-restrictions";
import HarryFox from "./harry-fox.vue";
import CountryRestrictionModal from "./country-restriction-modal";
import SelectMechanicalRate from "./select-mechanical-rate-modal";
import ExpandBox from "@plugins/expandable-box/expand-box";
import Metadata from "@dtplugins/metadata/metadata";
import Royalty from "./royalty";
import OpenOrder from "./open-order";
import StandardMechanicalRate from "./standard-mechanical-modal";
import EditStockModal from "./edit-stock-modal";
import AddTrackListModal from "./add-tracklist-modal";
import DuplicateTrackModal from "./duplicate-track-modal";
import ProductReleatedRelease from "./product-related-release.vue";
import CopyTrackModal from "./copy-track-modal";
//import DboxCosts from "@dtplugins/dbox-costs/dbox-costs";
import { createDboxCostConfig } from "../../../../dt-plugins/dbox-costs/dbox-costs.model";
import OnlyTracks from "./only-tracks";
import { ProductAccounts } from "../../store/types";

import DboxCosts from "@dtplugins/dbox-costs/dbox-costs";
import DBoxSales from "@dtplugins/dbox-sales/dbox-sales";

// import { createDboxCostConfig } from "../../../../dt-plugins/dbox-costs/dbox-costs.model";
import { createDboxPluginStoreConfig } from "../../../../dt-plugins/dboxstore/dboxstore";
import { ProductsService } from "../../services/products.service";
import DBoxRelatedReleases from "@/dt-plugins/dbox-related_releases/dbox-related_releases";
import TemplateModal from "./template-modal.vue";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import {
  ConfirmationService,
  createConfirmResult,
} from "@/dt-plugins/confirmation/confirmation.service";
import {
  distributionSupplierListLDTRoutes,
  distributionSupplierOrderListLDTRoutes,
} from "../../../distribution/router/routes";
import { routeWithFrom } from "../../../../utility/route";
import DTTaskList from '@/dt-plugins/dt-task/dt-related-task.vue'
import { createDboxConfig } from "../../../../dt-plugins/dt-task/dbox-task.model";

export const moduleRoute = "catalog";
export const submenuRoute = "products";

export default {
  components: {
    // GridLayout: VueGridLayout.GridLayout,
    // GridItem: VueGridLayout.GridItem,
    BoxWidget,
    DBox,
    DBoxTextarea,
    DList,
    DBoxFiles,
    StockSetup,
    CountryRestriction,
    Artwork,
    SelectMechanicalRate,
    ProductSetup,
    AdvancedProductSetup,
    StockLocation,
    Prices,
    Accounts,
    Tracklisting,
    GEMA,
    Manufacture,
    ProductInfo,
    Stocks,
    StockSupplyOrder,
    BackOrders,
    ManualMatches,
    HarryFox,
    ExpandBox,
    Metadata,
    Royalty,
    OpenOrder,
    EditStockModal,
    AddGroupModal,
    AddAccountModal,
    AddProductMediaModal,
    AddManufactureModal,
    AddBackOrderModal,
    AddManualManualMatches,
    CountryRestrictionModal,
    StandardMechanicalRate,
    AddTrackListModal,
    ModalContainer,
    DuplicateTrackModal,
    CopyTrackModal,
    DboxCosts,
    DBoxSales,
    OnlyTracks,
    TemplateModal,
    ProductReleatedRelease,
    DTTaskList,
    StockRelocationModal
  },
  data: function () {
    return {
      selectedStock: null,
      selectedTrack: null,

      syncedGridLayoutArray: null,

      active: -1,

      lockLoading: false,

      dBoxSalesSearchFlag: false,

      dBoxCostSearchFlag: false,
      dBoxOtherIncomeSearchFlag: false,

      modalWidth: "small",
    };
  },
  mixins: [
    createModalMixin("copyTrackModal"),
    createModalMixin("duplicateTrackModal"),
    createModalMixin("addTrack"),
    createModalMixin("editStock"),
    createModalMixin("standardMechanicalRate"),
    createModalMixin("addCountryRestrict"),
    createModalMixin("addMechanicalRate"),
    createModalMixin("addManualMatch"),
    createModalMixin("addBackOrder"),
    createModalMixin("addManufacture"),
    createModalMixin("addProductMedia"),
    createModalMixin("addProductGroup"),
    createModalMixin("addProductAccount"),
    createModalMixin("templateList"),
    createModalMixin("stockRelocationModal"),

    createDTGridHost(),

    createModalMixin("assignInvoiceContact"),
  ],
  mounted: function () {
    this[ActionTypes.ProductsCatalogData.FETCH.ALL]();

    setTimeout(() => {}, 5000);
  },
  computed: {
    ...mapGetterObject(storeNS, productsCatalogGetters),
    trackLength:function(){
      
      return  this.selectedProductDetails &&
                this.selectedProductDetails.tracks &&
                this.selectedProductDetails.tracks.length||0  
    },

    dBoxSalesRowHeight: function () {
      console.log(
        "Sales Array",
        this.selectedProductDetails?.salesData?.sales?.length > 0 ? 48 : 28
      );
      return this.selectedProductDetails?.salesData?.sales?.length > 0
        ? 48
        : 28;
    },

    dBoxSalesRowCount: function () {
      return this.selectedProductDetails?.salesData?.sales?.length > 0
        ? this.selectedProductDetails?.salesData?.sales?.length
        : 0;
    },
    releatedReleases: function() {
        return this.selectedProductDetails.releases || [];
      
    },
    isPhysical() {
      return this.selectedProductDetails?.product?.digital_physical ==
        "physical"
        ? true
        : false;
    },
    isDigital() {
      return this.selectedProductDetails?.product?.digital_physical == "digital"
        ? true
        : false;
    },
    product_id: function () {
      return this.$route.params.product_id;
    },
    selectedProductDetails: function () {
      const productDetails = this.productDetails?.[this.product_id] || {};

      const product = productDetails.product || {};

      const product_more_info = productDetails.product_more_info || {};

      const label_statuses = productDetails.label_statuses || [];

      const { product_release } = productDetails;
      const { catalog_no, barcode, digital_physical } = product || {};
      const { release_artist, release_title, release_date } =
        product_release || {};
      const title = `${catalog_no || ""} ${release_artist || ""} ${
        release_title || ""
      }`;
      const subtitle = `${barcode || ""} ${digital_physical || ""} ${
        release_date || ""
      }`;

      const formats = productDetails.all_l_formats || [];
      const formatsTV = formats.map(tv("format_name", "format_id"));

      const priceCodes = productDetails.all_price_codes || [];
      const release = productDetails.product_release || {};
      const releases=[release]||[]
      const priceCodesTV = priceCodes.map(
        tv("price_code_name", "price_code_id")
      );

      const yesNoTV = [
        {
          text: "Yes",
          value: 1,
        },
        {
          text: "No",
          value: 0,
        },
      ];

      const track_product_languages =
        productDetails.track_product_languages || [];
      const track_product_languagesTV = track_product_languages.map(tv());

      const categories1 = productDetails.categories1 || [];

      const categories1TV = categories1.map(
        tv("product_type_name", "product_type_id")
      );

      const categories2 = productDetails.categories2 || [];
      const categories2TV = categories2.map(
        tv("product_type_name", "product_type_id")
      );

      const all_stock_locations = productDetails.all_stock_locations || [];
      const all_stock_locationsTV = createTV(
        all_stock_locations,
        "stock_location_name",
        "stock_location_id"
      );
      const suppliers = productDetails.suppliers || [];
      const suppliersTV = createTV(suppliers, "supplier_name", "supplier_id");
      const groups = productDetails.groups || [];

      const contract = productDetails.contract || [];

      const product_title_lines = productDetails.product_title_lines || {};

      // if (product.digital_physical == "digital") {
      //   this.gdi("submenu_GROUPS").y = 10.3;
      // }

      return {
        ...productDetails,
        product_more_info,
        product_title_lines,
        label_statuses,
        title,
        subtitle,
        product,
        formats,
        formatsTV,
        priceCodes,
        priceCodesTV,
        yesNoTV,
        track_product_languagesTV,
        categories1TV,
        categories2TV,
        all_stock_locationsTV,
        groups,
        suppliers,
        suppliersTV,
        contract,
        releases
      };
    },

    countriesRowCount: function () {
      const countryAllowedLength =
        this.selectedProductDetails?.countries_allowed?.length || 0;

      const countryLength = this.selectedProductDetails?.countries?.length || 0;

      return parseInt((countryLength + countryAllowedLength) / 2);
    },

    dBoxTaskConfig:function(){
      return createDboxConfig({
        storeNamesPace: storeNS,
        detailsAction: ActionTypes.ProductDetails,
        detailsGetterKey: "productDetails",
        dataKey: "tasks",
        primaryKeyValue: this.product_id,
        externalTable: "product",
      })
    },

    dboxCostConfig: function () {
      return createDboxCostConfig({
        storeNamesPace: storeNS,
        detailsAction: ActionTypes.ProductDetails,
        detailsGetterKey: "productDetails",
        dataKey: "costs",
        primaryKeyValue: this.product_id,
        externalTable: "product",
      });
    },
    dboxCostIncomeConfig: function () {
      return createDboxCostConfig({
        storeNamesPace: storeNS,
        detailsAction: ActionTypes.ProductDetails,
        detailsGetterKey: "productDetails",
        dataKey: "other_incomes",
        primaryKeyValue: this.product_id,
        externalTable: "product_income",
      });
    },

    selectedProductDetailsId: function () {
      return this.selectedProductDetails?.invoice?.invoice_id;
    },
    contact_relation_table: function () {
      return this.selectedProductDetails.contact.getExternalTable();
    },
   
    menuOptions: function () {
     return this.isPhysical?[
          {
            text: this.$t('labelcopy'),
            value: 'labelcopy',
          },
          {
                text: this.$t("stock_move"),
                value: "stock_move",
          }]:[
          {
            text: this.$t('labelcopy'),
            value: 'labelcopy',
          },
              ]
  
      
    },
    productSidewindowTabs: function () {
      let tabList =this.isPhysical? [
        {
          route: "overview",
          value: this.$t("overview"),
          vgi_id: "product_setup",
        },
        {
          route: "tab_title_tasks",
          value: this.$t("tab_title_tasks"),
          vgi_id: "tab_title_tasks",
        },
        {
          route: "products_tracks",
          value: this.$t("products_tracks"),
          vgi_id: "products_tracks",
        },
        {
          route: "products_info",
          value: this.$t("products_info"),
          vgi_id: "products_info",
        },
        {
          route: "products_costs",
          value: this.$t("products_costs"),
          vgi_id: "products_costs",
        },
        {
          route: "products_other_income",
          value: this.$t("products_other_income"),
          vgi_id: "products_other_income",
        },
        {
          route: "products_royalty",
          value: this.$t("products_royalty"),
          vgi_id: "products_royalty",
        },
        {
          route: "products_sales",
          value: this.$t("products_sales"),
          vgi_id: "products_sales",
        },
        {
          route: "products_stock",
          value: this.$t("products_stock"),
          vgi_id: "products_stock",
        },
        {
          route: "products_specials",
          value: this.$t("products_specials"),
          vgi_id: "products_specials",
        },
        {
          route: "products_metadata",
          value: this.$t("products_metadata"),
          vgi_id: "products_metadata",
        },
      ]:[
        {
          route: "overview",
          value: this.$t("overview"),
          vgi_id: "product_setup",
        },
        {
          route: "tab_title_tasks",
          value: this.$t("tab_title_tasks"),
          vgi_id: "tab_title_tasks",
        },
        {
          route: "products_tracks",
          value: this.$t("products_tracks"),
          vgi_id: "products_tracks",
        },
        {
          route: "products_info",
          value: this.$t("products_info"),
          vgi_id: "products_info",
        },
        {
          route: "products_costs",
          value: this.$t("products_costs"),
          vgi_id: "products_costs",
        },
        {
          route: "products_other_income",
          value: this.$t("products_other_income"),
          vgi_id: "products_other_income",
        },
        {
          route: "products_royalty",
          value: this.$t("products_royalty"),
          vgi_id: "products_royalty",
        },
        {
          route: "products_sales",
          value: this.$t("products_sales"),
          vgi_id: "products_sales",
        },
       
        {
          route: "products_specials",
          value: this.$t("products_specials"),
          vgi_id: "products_specials",
        },
        {
          route: "products_metadata",
          value: this.$t("products_metadata"),
          vgi_id: "products_metadata",
        },
      ];
      return this.isPhysical
        ? checkTabListPermission(moduleRoute, submenuRoute, tabList)
        : checkTabListPermission(
            moduleRoute,
            submenuRoute,
            tabList.filter((x) => x.route != "stock")
          );
    },
    invoiceObj: function () {
      return pathOr(undefined, ["invoice"], this.selectedProductDetails);
    },
    lock_flag: function () {
      return pathOr("", ["invoice", "lock_flag"], this.selectedProductDetails);
    },
    status_color: function () {
      return pathOr(
        "",
        ["invoice", "status_color"],
        this.selectedProductDetails
      );
    },
    // TABULATION REFACTORING
    invoice_id: function () {
      return this.$route.params.invoice_id;
    },

    dboxSalesStoreConfig() {
      return createDboxPluginStoreConfig({
        storeNamesPace: storeNS,
        detailsAction: ActionTypes.ProductDetails,
        detailsGetterKey: "productDetails",
        dataKey: "salesData",
        primaryKeyValue: this.product_id,
      });
    },
    dBoxCostsRowCount() {
      return this.selectedProductDetails?.costs?.length > 0
        ? this.selectedProductDetails?.costs?.length
        : 0;
    },
    dBoxOtherIncomesRowCount: function () {
      return this.selectedProductDetails?.other_incomes?.length > 0
        ? this.selectedProductDetails?.other_incomes?.length
        : 0;
    },

    productSetupHeight() {
      if (this.isPhysical) {
        const height =
          338 +
          (this.selectedProductDetails?.product?.preorder_date ? 32 : 0) +
          (this.selectedProductDetails?.product?.alt_artist ? 32 : 0) +
            (this.selectedProductDetails?.product?.alt_title ? 32 : 0) +
            (this.selectedProductDetails?.product?.release_shift ? 32 : 0);
            console.log('height',height)
        return {
          h: height,
          maxH: height + 64,
        };
      } 
      else {
        return {
          h: 338  + (this.selectedProductDetails?.product?.preorder_date ? 32 : 0),
          maxH: 402 + (this.selectedProductDetails?.product?.preorder_date ? 32 : 0),
        };
      }
    },
    //MARK: Computed
  },
  methods: {
    ...mapActionObject(storeNS, productsCatalogActions),

    onDBoxSalesSearchClick: function (payload) {
      console.log("SEARCH FLAG", payload);
      this.dBoxSalesSearchFlag = payload;
    },

    onProductChange: function (payload) {
      console.log({ payload: payload });
      this[ActionTypes.ProductDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails,
      });
    },
    onPriceChange: function (payload) {
      this[ActionTypes.PriceList.UPDATE.SINGLE]({
        ...payload,
        product: this.selectedProductDetails.product,
      });
    },
    ongroupDelete: function (group) {
      // console.log("DELETE GROUP", group);
      this[ActionTypes.ProductGroups.DELETE.SINGLE]({
        group: group,
        item: this.selectedProductDetails.product,
      });
    },
    onGroupClick: function (group) {
      console.log({ group: group });
      const { product_group_id } = group;
      // this.$router.push({
      //   name: productGroupsLDTRoutes.names.tab,
      //   params: {
      //     product_group_id,
      //     tab: "overview",
      //   },
      // });
      routeWithFrom(this, {
        name: productGroupsLDTRoutes.names.tab,
        params: {
          product_group_id,
          tab: "overview",
        },
      });
    },
    addgroupClick: function (group) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_product_group",
          external_id: this.selectedProductDetails.product.product_id,
        },
      });
    },
    onFileDelete: function () {},
    onArtworkChanged: function (payload) {
      this[ActionTypes.SET_CATALOG_PRODUCT_ARTWORK]({
        ...payload,
        selectedProductDetails: this.selectedProductDetails,
      });
    },
    onUpdated: function(payload) {
      // this[ActionTypes.LabelDetails.UPDATE.SINGLE]({
      //   ...payload,
      //   selectedLabelDetails: this.selectedLabelDetails
      // });
    },
    onArtworkUploadDone: function (payload) {
      this[ActionTypes.SET_CATALOG_PRODUCT_ARTWORK]({
        ...payload,
        selectedProductDetails: this.selectedProductDetails,
      });
      this[ActionTypes.SET_CATALOG_PRODUCT_FILES]({
        ...payload,
        selectedProductDetails: this.selectedProductDetails,
      });
    },
    async onProductCostAccountAll() {
      this.$emit("closed", true);
      const { release_id } = this.selectedProductDetails.product;
      this.$router.push({
        name: productsListLDTRoutes.names.list,
      });
      await wait(100);
      this.$router.push({
        path: "/main/royalty/recoupable",

        query: {
          release_id,
        },
      });
    },
    async onProductIncomeAccountAll() {
      const { release_id } = this.selectedProductDetails.product;

      this.$router.push({
        name: productsListLDTRoutes.names.list,
      });
      await wait(100);
      this.$router.push({
        path: "/main/royalty/recoupable",

        query: {
          release_id,
        },
      });
    },
    onExpandAdvancedProductSetup(flag) {
      if (flag) {
        this.gdi("advanced_product_setup").h += 5;
      } else {
        this.gdi("advanced_product_setup").h -= 5;
      }
    },
    onTabOptionClicked(value) {
      console.log("value", value);
      if (value == "labelcopy") {
        this.copyLabel();
      } 
     else if (value == "stock_move") {
      openModalRoute2(this, "stockRelocationModal", {
          external_id: this.product_id,
        });
      } 
      else {
        openModalRoute2(this, "dtTemplateList", {
          external_id: this.product_id,
        });
      }
    },
    async stockMove(payload){
      const resData = await ProductsService.reallocateStock(payload);
      this[ActionTypes.SET_STOCK_RELOCATION](payload);
      this.onCancel();
    },
    async copyLabel() {
      const resData = await ProductsService.getLabelcopy(this.product_id);
      console.log(":::::", resData);
      const product = resData.data.product[0];
      const artist = `Artist: ${product.release_artist}\n`;
      const title = `Title: ${product.release_title}\n`;
      const catalog_no = `Catalog No: ${product.catalog_no}\n`;
      const format = `Format:${product.format_name}\n`;
      const barcode = `Barcode: ${product.barcode}\n`;
      const release_date_shift = `Release: ${product.release_date_shift}\n`;
      const trackListLabel = `---------------------------------------------------------\n---------------------------------------------------------\n---------------------------------------------------------\nTracklisting\n---------------------------------------------------------\n`;

      const trackList = product.product_tracks;

      const initialBody =
        artist +
        title +
        catalog_no +
        format +
        barcode +
        release_date_shift +
        trackListLabel;

      const finalBody = trackList.reduce((accum, cur) => {
        accum += `Medium: ${cur.set_no}// Side:  // Track: ${cur.seq_no}\n\n`;

        accum += `Artist: ${cur.artist}\n Title: ${cur.title}\n Playtime:${
          cur.playtime
        }\n Explicit Lyrics: ${cur?.explicit_flag || "No"}\n ISRC: ${
          cur.isrc
        }\n (P): \nCountry: ${cur.country}\n`;

        accum += `---------------------------------------------------------\n`;
        return accum;
      }, initialBody);

      console.log("finalBody", finalBody, trackList);
      const subject = `${artist} - ${title} | ${catalog_no}`;

      const mails = [""];
      console.log("{ subject,body:finalBody, mails }", {
        subject,
        body: finalBody,
        mails,
      });
      sendMailHref({ subject, body: finalBody, mails });
    },
    async onProductCostUpdated(payload) {
      const res = await ProductsService.costTab(this.product_id);
      const { product_costs_total } = res.data;

      this[ActionTypes.UPDATE_PRODUCT_DETAILS_STATE]({
        product_costs_total,
        product_id: this.product_id,
      });
    },
    onAddGroup: function (payload) {
      this[ActionTypes.ProductGroups.INSERT.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
      this.onCancel();
    },
    onAccountDelete: function (payload) {
      this[ActionTypes.ProductAccounts.DELETE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
    },

    onAddAccount: function (payload) {
      this[ActionTypes.ProductAccounts.INSERT.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
      this.onCancel();
    },

    onDeleteTrack: async function (payload) {
      await this[ActionTypes.ProductTracks.DELETE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });

      const item = this.selectedProductDetails.product;

      console.log("::::::::::::::", item);
      await this[ActionTypes.OnlyTracks.SET.ALL]({
        ...item,
      });
    },
    onDeleteProductMedia: function (payload) {
      this[ActionTypes.ProductMedia.DELETE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
    },
    onPriceLoad: function (payload) {
      this[ActionTypes.PriceList.SET.ALL]({
        payload,
        item: this.selectedProductDetails.product,
      });
    },
    onDeletePrice: function (payload) {
      this[ActionTypes.PriceList.DELETE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
    },

    onAddProductMedia: function (payload) {
      this[ActionTypes.ProductMedia.INSERT.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
      this.onCancel();
    },

    onUpdateProductMedia: function (payload) {
      this[ActionTypes.ProductMedia.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
      this.onCancel();
    },

    onAddManufacture: async function (payload) {
      const list = await this[ActionTypes.ProductManufacture.INSERT.SINGLE](
        payload
      );

      const index = list.length - 1;
      this.onCancel();

      const supplier = list[index];
      //distributionSupplierListLDTRoutes;
      distributionSupplierOrderListLDTRoutes;
      this.$router.push({
        name: distributionSupplierOrderListLDTRoutes.names.tab,
        params: {
          supplier_order_id: supplier.supplier_order_id,
          tab: "overview",
        },
      });
    },
    onAddBackOrder: function (payload) {
      this[ActionTypes.BackOrder.INSERT.SINGLE](payload);
      this.onCancel();
    },
    onAddBackOrder: function (payload) {
      this[ActionTypes.BackOrder.INSERT.SINGLE](payload);
      this.onCancel();
    },
    onDeleteBackOrder: function (payload) {
      this[ActionTypes.BackOrder.DELETE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
    },
    onDeleteOpenOrder: function (payload) {
      this[ActionTypes.OpenOrder.DELETE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
    },
    onManualMatchDelete: function (payload) {
      this[ActionTypes.ProductManualMatches.DELETE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
    },
    onAddManualMatch: function (payload) {
      this[ActionTypes.ProductManualMatches.INSERT.SINGLE]({
        item: payload,
        product: this.selectedProductDetails.product,
      });
      this.onCancel();
    },
    onCountryDelete: function (payload) {
      this[ActionTypes.CountryRestricted.DELETE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
    },
    onSelectedRelease: function(selectedReleaseId) {
      if (selectedReleaseId) {
        this.$router.push({
          name: releasesListLDTRoutes.names.tab,
          params: {
            release_id: selectedReleaseId,
            tab: "overview"
          }
        });
      }
    },
    onRemoveClick: function () {
      this[ActionTypes.CountryRestricted.DELETE.ALL](
        this.selectedProductDetails.product
      );
    },
    onInvertClick: function () {
      this[ActionTypes.CountryRestricted.SET.ALL](
        this.selectedProductDetails.product
      );
    },
    onAddCountryRestrict: function (payload) {
      this[ActionTypes.CountryRestricted.INSERT.SINGLE](payload);
      this.onCancel();
    },
    onSaveMechanicalRate: function (payload) {
      this[ActionTypes.HarryFox.UPDATE.SINGLE](payload);
      this.onCancel();
    },

    onMetaDataUpdate: function (payload) {
      // console.log("ONUPDATE", payload);
      this[ActionTypes.ProductMetaData.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
    },
    setSelectedStock: function (item) {
      // console.log("::::", item);
      this.selectedStock = item;
      this.$router.push({
        ...this.$route,
        query: {
          modal: "edit_stock",
          product_id: this.selectedProductDetails.product.product_id,
        },
      });
    },
    onEditStock: function (payload) {
      this[ActionTypes.Stocks.UPDATE.SINGLE](payload);
      this.onCancel();
    },
    onRoyaltyChange: function (payload) {
      this[ActionTypes.Royalty.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
    },
    onRoyaltyReleaseUpdate: async function () {
      const confirmationResult = await ConfirmationService.createP({
        body: this.$t("update_release_contract_confirmation"),
        results: [
          createConfirmResult({
            value: "no",
            text: "No",
          }),
          createConfirmResult({
            value: "yes",
            text: "Yes",
            classes: ["v1"],
          }),
        ],
      });

      if (confirmationResult === "yes") {
        this[ActionTypes.Royalty.UPDATE.MULTIPLE](
          this.selectedProductDetails.product
        );
      }
    },
    setDuplicateModalData: function (item) {
      this.selectedTrack = item;
      this.$router.push({
        ...this.$route,
        query: {
          modal: "duplicate_track_modal",
          product_id: this.selectedProductDetails.product.product_id,
        },
      });
    },
    onAddTrackList: async function (payload) {
      await this[ActionTypes.TrackList.INSERT.SINGLE](payload);
      await this[ActionTypes.OnlyTracks.SET.ALL](payload);
      this.onCancel();
    },

    onCopyTrackList: function (payload) {
      this[ActionTypes.SET_COPY_TRACK](payload);
      this.onCancel();
    },
    onTrackChange: function (payload) {
      this[ActionTypes.TrackList.UPDATE.SINGLE](payload);
    },
    updatePlayTime: function (payload) {
      this[ActionTypes.UPDATE_PLAYTIME](payload);
    },
    onUpdateOnlyTrack: function (payload) {
      console.log("PAYLOAD", payload);
      this[ActionTypes.OnlyTracks.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedProductDetails.product,
      });
    },
    onLoadAccounts: function () {
      this[ActionTypes.ProductAccounts.SET.ALL](
        this.selectedProductDetails.product
      );
    },
    onCancel: function () {
      this.$router.push({
        query: {
          modal: undefined,
          external_id: undefined,
        },
      });
    },

    onDBoxCostSearchFlagChange(payload) {
      this.dBoxCostSearchFlag = payload;
    },
    onDBoxOtherIncomeSearchFlagChange(payload) {
      this.dBoxOtherIncomeSearchFlag = payload;
    },

    onChangeWidth: function (type) {
      console.log(type);
      if (type == "new") {
        this.modalWidth = "small";
      } else {
        this.modalWidth = "medium";
      }
    },

    // MARK: Methods
  },
};
</script>

<style lang="scss"></style>

<style lang="scss">
.cmp-catalog-products-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 150px);
  }
  .overview-options {
    margin-top: 7%;
    .icons {
      display: flex;
      justify-content: center;
      img:first-child {
        padding-top: 2px;
      }
      img {
        cursor: pointer;
      }
      .loading-icon-container {
        width: 30px;
        .loading-icon {
          width: 15px;
          height: 15px;
          padding-left: 5px;
        }
      }

      .status {
        margin-top: 17px;
        margin-left: 5px;
        .circle {
          width: 15px;
          height: 15px;
          border-radius: 30px;
        }
      }
    }
  }
}
</style>
